import { createSingleEntityStore } from '@recruitee/ngrx';

import { EntityStoreKey, NotificationCounterStore } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<NotificationCounterStore>()(EntityStoreKey.notificationsCounter);

export {
  actions as NotificationsCounterActions,
  selectors as NotificationsCounterSelectors,
  reducer as NotificationsCounterReducer,
  namespace as NotificationsCounterNamespace,
};
